module.exports = __webpack_public_path__ + "img/9-full-md.95ba624a.jpg";